import {
  Chelist,
  EditProjectRequestDetails,
  GetProjectRequestMailIds,
} from '../../../../types/ProjectManagement/ProjectCreationRequests/EditProjectRequest/editProjectRequestTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  EditProjectCreationRequestApiConfig,
} from '../../apiList'

const getEditCheckList = async (): Promise<Chelist[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: EditProjectCreationRequestApiConfig.getCheckList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getEditProjectRequestMailIds =
  async (): Promise<GetProjectRequestMailIds> => {
    const requestConfig = getAuthenticatedRequestConfig({
      url: EditProjectCreationRequestApiConfig.getProjectRequestMailIds,
      method: AllowedHttpMethods.get,
    })

    const response = await useAxios(requestConfig)
    return response.data
  }

const editProjectRequest = async (
  addProjectRequestDetails: EditProjectRequestDetails,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: EditProjectCreationRequestApiConfig.editProjectRequest,
    method: AllowedHttpMethods.post,
    data: addProjectRequestDetails,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const editProjectCreationRequestApi = {
  getEditCheckList,
  getEditProjectRequestMailIds,
  editProjectRequest,
}
export default editProjectCreationRequestApi
